<template>
  <div>
    <!--begin::Content header-->
    
    <!--end::Content header-->
      <!--begin::Form-->
      <b-form class="form-signin d-flex align-items-stretch flex-column" @submit.stop.prevent="onSubmit">
        <div class="text-center mb-2">
          <img class="mb-2" src="media/img/femsa.png" alt="" width="120">
          <h3 class="mb-0">Iniciar Sesión</h3>
        <span>Cambia tu contraseña E</span>
        </div>

        <div
          role="alert" v-show="errors.length>0"
          v-bind:class="{ show: errors.length }"
          class="alert alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>
       
        <div v-if="step2" class="d-flex align-items-stretch flex-column">
              <div class="alert alert-success messaging">
              <svg data-v-bc4e6392="" viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="exclamation circle" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-exclamation-circle mx-auto b-icon bi"><g data-v-bc4e6392=""><path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path><path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"></path></g></svg>
              Su contraseña ha sido cambiada de forma correcta.
                <p>Ya puedes iniciar sesión. <router-link
                         
                          :to="{ name: 'login-executive' }"
                        >
           Ir al login
          </router-link></p>
            </div>
        </div>


        <div v-if="!step2" class=" d-flex align-items-stretch flex-column">
         <div class="alert alert-secondary messaging">
            <svg data-v-bc4e6392="" viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="exclamation circle" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-exclamation-circle mx-auto b-icon bi"><g data-v-bc4e6392=""><path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path><path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"></path></g></svg>
            HOLA, {{user.nombres}}, para continuar debes cambiar tu contraseña temporal.
          </div>

        <div class="form-label-group">
          <label for="inputPassword">Contraseña</label>
          <b-form-input
            class="form-control"
            type="password"
            id="example-input-1"
            name="example-input-1"
            v-model="$v.form.password.$model"
            placeholder="Nueva contraseña"
            :state="validateState('password')"
            aria-describedby="input-1-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback">
            Contraseña es requerida.
          </b-form-invalid-feedback>
           <small class="text-muted">
            La contraseña debe tener al menos 8 caracteres, una mayúscula, un número y un carácter especial
          </small>
          <div v-if="$v.form.password.$dirty" class="password-requirements text-danger">
            <small v-if="!$v.form.password.minLength">❌ Falta: Mínimo 8 caracteres</small>
            <small v-if="!$v.form.password.containsUppercase">❌ Falta: Una letra mayúscula</small>
            <small v-if="!$v.form.password.containsNumber">❌ Falta: Un número</small>
            <small v-if="!$v.form.password.containsSpecial">❌ Falta: Un carácter especial</small>
          </div>
        </div>
        <div class="form-label-group">
          <label for="inputPassword">Confirme Contraseña</label>
          <b-form-input
            class="form-control"
            type="password"
            id="example-input-2"
            name="example-input-2"
            placeholder="Confirme contraseña"
            v-model="$v.form.passwordConfirm.$model"
            :state="validateState('passwordConfirm')"
            aria-describedby="input-2-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-2-live-feedback">
            Confirmación Contraseña es requerida.
          </b-form-invalid-feedback>
          </div>
       
        <!--begin::Action-->
         <button
            ref="kt_login_signin_submit"
            class="btn btn-primary align-self-center"
          >
            Cambiar Clave
          </button>
        </div>
        <p class="mt-3 mb-3 text-muted text-center">
          <router-link
                          class="text-dark-60 text-hover-primary my-3 mr-2"
                          :to="{ name: 'login-executive' }"
                        >
           Volver
          </router-link>
        </p>
        <!--end::Action-->
      </b-form>
      <!--end::Form-->
    
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import { mapState } from "vuex";
import { GET_USER, CHANGE_USER_PASSWORD } from "@/core/services/store/user.module";

import { validationMixin } from "vuelidate";
import { minLength, required, sameAs } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "changePassword",
  data() {
    return {
      step2:false,
      user:{},
      // Remove this dummy login info
      form: {
        passwordConfirm: "",
        password: ""
      }
    };
  },
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(8),
        containsUppercase: function(value) {
          return /[A-Z]/.test(value);
        },
        containsNumber: function(value) {
          return /[0-9]/.test(value);
        },
        containsSpecial: function(value) {
          return /[!@#$%^&*(),.?":{}|<>]/.test(value);
        }
      },
      passwordConfirm: {
        required,
        minLength: minLength(3),
        sameAsPassword:sameAs('password')
      }
    }
  },
  mounted () {
    this.getUser();
  },
  methods: {
    getUser() {
      this.$Progress.start();
      this.$store
          .dispatch(GET_USER, this.$route.params.token)
          .then((response)=>{this.user = response, this.$Progress.finish()});
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        passwordConfirm: null,
        password: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const confirmacionClave = this.$v.form.passwordConfirm.$model;
      const nuevaClave = this.$v.form.password.$model;
      const token = this.$route.params.token;
      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      setTimeout(() => {
        this.$store
          .dispatch(CHANGE_USER_PASSWORD, { token, nuevaClave, confirmacionClave })
          .then(() => this.step2=true);

        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }, 500);
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    })
  }
};
</script>
<style scoped>
.messaging {font-size: 0.8em;}
.alert-success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
}
.password-requirements small {
  display: block;
  font-size: 0.8em;
  margin-top: 2px;
}
</style>